'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nestedHateoasCommonModels = require('@unitedtraders/nested-hateoas-common-models');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Market = function (_Enum) {
  _inherits(Market, _Enum);

  function Market() {
    _classCallCheck(this, Market);

    return _possibleConstructorReturn(this, (Market.__proto__ || Object.getPrototypeOf(Market)).apply(this, arguments));
  }

  return Market;
}(_nestedHateoasCommonModels.Enum);

Market.initEnum(['Micex', 'Rts', 'UsEquities', 'UsOptions', 'UsCme', 'UsVirtual', 'HitBtc', 'Utex', 'MicexDemo', 'RtsDemo', 'UsEquitiesDemo', 'UsOptionsDemo', 'UsCmeDemo', 'UsVirtualDemo', 'HitBtcDemo', 'UtexDemo']);

exports.default = Market;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/statements-domain/dist/models/enums/Market.js
// module id = 31
// module chunks = 118